// extracted by mini-css-extract-plugin
export default {"uploadPlaceholder":"ErpProductImageUpload_uploadPlaceholder__4F4mr"};